import React from 'react';
import {
    HeadingText60,
    HeadingText20,
    ComponentTextSmall,
    ProgressBar,
} from '@modernhealth/vital-components';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

import type { PathwayProviderFragment } from 'src/modules/pathways/documents/fragments.generated';

interface Props {
    title: string;
    currentSessionIndex: number;
    totalSessions: number;
    progressPercentage: number; // Float
    pathwayProvider: PathwayProviderFragment;
}

export const PathwayDetailHeader = ({
    title,
    currentSessionIndex,
    totalSessions,
    progressPercentage,
    pathwayProvider,
}: Props) => {
    const { t } = useTranslation();

    return (
        <PathwayDetailHeaderContainer>
            {pathwayProvider.provider.avatar && (
                <ProviderAvatar src={pathwayProvider.provider.avatar} />
            )}
            <PathwayDetailHeaderRight>
                <HeadingText20>{t('pathways:your_pathway')}</HeadingText20>
                <HeadingText60>
                    {t('pathways:pathway_detail.title', {
                        title: title,
                        firstName: pathwayProvider.provider.firstName,
                        lastName: pathwayProvider.provider.lastName,
                    })}
                </HeadingText60>
                <ComponentTextSmall marginBottom={10}>
                    {t('pathways:pathway_detail.progress', {
                        current: currentSessionIndex + 1,
                        total: totalSessions,
                        percentage: progressPercentage,
                    })}
                </ComponentTextSmall>
                <ProgressBar progress={progressPercentage / 100} />
            </PathwayDetailHeaderRight>
        </PathwayDetailHeaderContainer>
    );
};

const PathwayDetailHeaderContainer = styled.div({
    display: 'flex',
    marginTop: 50,
    marginBottom: 50,
});

const PathwayDetailHeaderRight = styled.div({
    flex: 1,
});

const ProviderAvatar = styled.img({
    width: 125,
    height: 125,
    borderRadius: '50%',
    margin: '0 auto',
    display: 'block',
    border: 'none',
    objectFit: 'cover',
    objectPosition: 'center',
    marginRight: 30,
});
